import { Component, OnInit } from '@angular/core';
import {DoraDataGridSelectorComponent} from '../dora-data-grid-selector.component';
import {MessageGridSelected} from '../../../messages/message-grid-selected';
import {DataRow} from '../../../DoraData/data-row';
import {DataTupla} from '../../../DoraData/data-tupla';
import {DoraProperty} from '../../../Decorators/Decorator';

@Component({
  selector: 'dora-data-grid-selector-lb',
  templateUrl: './dora-data-grid-selector-lb.component.html',
  styleUrls: ['./dora-data-grid-selector-lb.component.scss']
})
export class DoraDataGridSelectorLbComponent extends DoraDataGridSelectorComponent {

  private selectedStr = '';

  // GridList
  public gridList: Array<any> = [];

  @DoraProperty
  private placeholder = 'ng2-select-placeholder';

  /**
   * Received new data
   */

  protected onNewData(): void {
    super.onNewData();

    // empty list
    this.gridList = [];

    // @ts-ignore
    for (const dataRow: DataRow of this.dataRows) {
      const descriptionTupla: DataTupla = dataRow.getDataTupla('Description');

      if (descriptionTupla !== undefined) {
        // get id
        // tslint:disable-next-line:max-line-length
        this.gridList.push({id: dataRow.Id, text: `<div class="DAG-img-select" style="width: 10px; height: 10px; display: inline-block;"></div>${(descriptionTupla.Value as string)}`});
      }
    }
  }

  public selected(value: any): void {
    console.log('Selected value is: ', value);
    this.selectedGrid(value.id);
  }

  public removed(value: any): void {
    console.log('Removed value is: ', value);
  }

  public typed(value: any): void {
    console.log('New search input: ', value);
  }

  public refreshValue(value: any): void {
    this.selectedStr = value;
  }

  /**
   * Get placeholder for empty value.
   * It is translated
   */
  getPlaceholer() {
    if (this.flSelectFirstRow) {
      // get first row
      try {
        return this.dataGrid.DataRows[0].getDataTupla('Description').Value;
      } catch (e) {
        return '';
      }
    }

    return this.translationService.getWithDefault(this.placeholder, '');
  }
}
